export const chatChannels = [
    {value: 'general', label: 'Chat: General'},
    {value: 'buying', label: 'Chat: Buying'},
    {value: 'selling', label: 'Chat: Selling'},
    {value: 'looking_for', label: 'Chat: Looking for'},
]
